// extracted by css-extract-rspack-plugin
export default {"fieldset":"Fyc3y"};